var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolemanagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3913 2.17413H12.8478C12.6253 1.53874 12.2107 0.988217 11.6616 0.598718C11.1125 0.20922 10.4559 0 9.78261 0C9.10936 0 8.45276 0.20922 7.90362 0.598718C7.35448 0.988217 6.93996 1.53874 6.71739 2.17413H2.17391C1.59788 2.17585 1.04594 2.40544 0.638625 2.81276C0.231309 3.22007 0.00172036 3.77202 0 4.34805L0 19.5654C0.00172036 20.1415 0.231309 20.6934 0.638625 21.1007C1.04594 21.508 1.59788 21.7376 2.17391 21.7393H7.76196C7.55698 21.0292 7.55698 20.2756 7.76196 19.5654H2.17391V4.34805H17.3913V14.1307H19.5652V4.34805C19.5635 3.77202 19.3339 3.22007 18.9266 2.81276C18.5193 2.40544 17.9673 2.17585 17.3913 2.17413ZM9.78261 3.53283C9.56684 3.5314 9.36031 3.44506 9.20774 3.29248C9.05516 3.13991 8.96882 2.93338 8.96739 2.71761C8.96739 2.5014 9.05328 2.29405 9.20616 2.14117C9.35905 1.98828 9.5664 1.90239 9.78261 1.90239C9.99882 1.90239 10.2062 1.98828 10.3591 2.14117C10.5119 2.29405 10.5978 2.5014 10.5978 2.71761C10.5964 2.93338 10.5101 3.13991 10.3575 3.29248C10.2049 3.44506 9.99838 3.5314 9.78261 3.53283Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolemanagement);
export default __webpack_public_path__ + "static/media/rolemanagement.981595fd1d55fda43dde07277844685f.svg";
export { ForwardRef as ReactComponent };